import { render } from "./zhudanchuli.vue?vue&type=template&id=6fd328b4&scoped=true"
import script from "./zhudanchuli.vue?vue&type=script&lang=js"
export * from "./zhudanchuli.vue?vue&type=script&lang=js"

import "./zhudanchuli.vue?vue&type=style&index=0&id=6fd328b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd328b4"]])

export default __exports__